module.exports = __webpack_public_path__ + "static/media/UsagePurposes.62ed6e01.png";